import React from "react";

const CollectionCard = ({ title, items, image, description }) => {
  return (
    <a 
   
      className="collection-card__wrapper relative flex flex-col gap-6 focus-inset" 
      aria-label={title}
    >
      {/* Image Container */}
      <div className="collection-card__image media-wrapper hover-wrapper loaded" style={{ "--aspect-ratio": "1.0" }}>
        <img
          src={image}
          alt={title}
          width="1000"
          height="1000"
          loading="lazy"
          className="hover-scale-up w-full h-full object-cover loaded"
          style={{borderTopLeftRadius:"20px" , borderTopRightRadius:"20px"}}

        />
      </div>

      {/* Card Info */}
      <div className="collection-card__inner pointer-events-none" style={{padding:"10px"}}>
        <div className="collection-card__info flex items-center gap-2 w-full">
          <div className="collection-card__summary flex-1 flex flex-col gap-1 text-left">
            <h3 className="collection-card__title h4">{title}</h3>
            <p className="text-gray-600 text-sm">{description}</p>
            <div className="collection-card__count text-subtext">
              {items}
            </div>
          </div>
          <button className="btn btn--icon-circle btn--secondary shrink-0" aria-label={title}>
            <svg 
              className="icon icon--medium" 
              width="20" 
              height="20" 
              viewBox="0 0 20 20" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M5 15L15 5" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
              <path 
                d="M6.875 5H15V13.125" 
                stroke="currentColor" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </a>
  );
};

export default CollectionCard;